import { zUid } from "src/types/zUid";
import { z } from "zod";
import { Permission } from "src/types/Permission";

export const zRoleFields = z.object({
  name: z.string(),
  isCopy: z.boolean().optional(),
  copyRoleId: zUid.optional(),
  defaultPermissions: z.nativeEnum(Permission).array().optional(),
  copyForObjects: z.boolean().optional(),
  copyForAttributes: z.boolean().optional(),
});
export type ZRoleFields = z.infer<typeof zRoleFields>;
